export const headers = [
  { text: 'Thao tác', value: 'delete', width: '7rem'},
  { text: 'Mã', align: 'start', value: 'id', width: '7rem' },
  { text: 'Mã NS', align: 'start', value: 'employeeCode', width: '7rem' },
  { text: 'Từ', align: 'start', value: 'validFrom', width: '7rem' },
  { text: 'Đến', align: 'start', value: 'validTo', width: '7rem' },
  { text: 'Mô tả', align: 'start', value: 'description', width: 'auto' },
]